module.exports = __webpack_public_path__ + "img/BlinkArt_Sword15_Frost.ce787ea6.png";